const SESSION_KEY = 'sl-cognito-id-token';

let cachedToken: string | null = null;

export const setCognitoIdToken = (token: string | null): void => {
  cachedToken = token;
  if (token) {
    sessionStorage.setItem(SESSION_KEY, token);
  } else {
    sessionStorage.removeItem(SESSION_KEY);
  }
};

export const getCognitoIdToken = (): string | null => {
  if (cachedToken) return cachedToken;

  const stored = sessionStorage.getItem(SESSION_KEY);
  if (stored) {
    cachedToken = stored;
    return stored;
  }

  return null;
};

export const clearCognitoIdToken = (): void => {
  cachedToken = null;
  sessionStorage.removeItem(SESSION_KEY);
};
